import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import moment from "moment";
import { routePaths } from "../../../../config/route-paths";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";

const useStyle = makeStyles((theme) => ({
  greenLine: {
    backgroundColor: theme.palette.eInformation?.dark,
    padding: "3% 5%",
    color: theme.palette.eWhite?.base,
  },
  whiteColor: {
    color: theme.palette.eWhite?.base,
    "&:hover": {
      color: theme.palette.eWhite?.base,
    },
  },
  paddingContent: {
    // padding: "4vh 2vh !important",
    background: theme.palette.eWhite?.base,
    height: "20vh",
    [theme.breakpoints.down("md")]: {
      height: "14vh",
    },
  },
  paddingContentNEM: {
    paddingTop: "0.5rem",
    background: theme.palette.eWhite?.base,
   // height: "9.5vh",
    [theme.breakpoints.down("md")]: {
      height: "10vh",
    },
  },
  bigFontSize: {
    fontSize: "1.25rem",
    color: theme.palette.ePrimary.base,
  },
  orangeColor: {
    color: theme.palette.eTertiary?.base,
  },
  rechargeHistoryStyle: {
    textDecoration: "underline",
    color: theme.palette.eWhite?.base,
    "&:hover": {
      color: theme.palette.eWhite?.base,
    },
  },
}));
export default function E_LASTRECHARGE({latestDate,latestAmt}) {
  let classes = useStyle();
  let saDetails = useSelector((store) => store?.meterDetails?.getSaInfo);
  let curSymbol = useSelector((state) => state?.meterDetails?.curSymbol);
  let dateFormat = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.E_DATE_MONTH_YEAR_FORMAT
  );
  const { t: labels, ready: labelReady } = useTranslation(
    "label-E_PREPAID_ACCOUNTSUMMARY"
  );
  const EDGE_CURRENCY_SYMBOL = "BDT";
  const [currencySymbol, setCurrencySymbol] = useState("");
  let currencyCode = useSelector(
    (store) => store?.parametersWidgets?.ParameterLookup?.E_CURRENCY_CODE
  );
  const isNEMAccount = useSelector((store) => store?.meterDetails?.isNEMAccount)
  useEffect(() => {
    if (curSymbol) {
      setCurrencySymbol(
        curSymbol && curSymbol == EDGE_CURRENCY_SYMBOL
          ? currencyCode
          : curSymbol
      );
    }
  }, [curSymbol]);

  return (
    <Grid container spacing={0}>
      <Grid  xs={12} style={{ paddingBottom: 0 }}>
        <Grid
          container
          direction="row"
          justify="center"
          className={classes.greenLine}
        >
          <Grid item>
            <RouterLink
              to={routePaths.BILLING}
              className={classes.rechargeHistoryStyle}
            >
              {labelReady ? labels("E_RECHARGE_HISTORY") : <Skeleton />}
            </RouterLink>
          </Grid>
        </Grid>
      </Grid>
      {0==0 ? (
        <Grid item xs={12} className={classes.paddingContentNEM}>
          { latestDate&&labelReady ? (
            <Typography variant="body2" align="center">
              {saDetails?.prepaidSaDetail?.lastPayAmtOnSa &&
              saDetails?.prepaidSaDetail?.lastPayDateOnSa ? (
                <>
                  <Typography variant="body2" align="center">
                    <b>{labels("E_LAST_RECHARGE")}</b>{" "}<span className={classes.bigFontSize}><b>{currencySymbol +latestAmt +" "}</b></span>
       
                  
                  {labels("E_PREPAID_ON")} {moment(latestDate).format(dateFormat)}</Typography>
                  {/* <Typography variant="body2">
                    {labels("E_VIA") +
                      " " +
                      saDetails?.prepaidSaDetail?.payTenderSrc}
                  </Typography> */}
                </>
              ) : (
                <Typography align="center">
                  {labels("E_PREPAID_ACCOUNT_SUMMARY_NO_RECHARGE_FOUND")}
                </Typography>
              )}
            </Typography>
          ) : (
            <Skeleton />
          )}
        </Grid>
      ) : (
        <Grid item xs={12} className={classes.paddingContent}>
          {labelReady ? (
            <Typography variant="body2" align="center">
              {saDetails?.prepaidSaDetail?.lastPayAmtOnSa &&
              saDetails?.prepaidSaDetail?.lastPayDateOnSa ? (
                <>
                  <Typography variant="body2" align="center">
                    <b>{labels("E_LAST_RECHARGE")}</b>
                  </Typography>
                  <span className={classes.bigFontSize}>
                    <b>
                      {currencySymbol +
                        saDetails?.prepaidSaDetail?.lastPayAmtOnSa +
                        " "}
                    </b>
                  </span>
                  {labels("E_PREPAID_ON") +
                    " " +
                    moment(saDetails?.prepaidSaDetail?.lastPayDateOnSa).format(
                      dateFormat
                    )}{" "}
                  {/* <Typography variant="body2">
                    {labels("E_VIA") +
                      " " +
                      saDetails?.prepaidSaDetail?.payTenderSrc}
                  </Typography> */}
                </>
              ) : (
                <Typography>
                  {labels("E_PREPAID_ACCOUNT_SUMMARY_NO_RECHARGE_FOUND")}
                </Typography>
              )}
            </Typography>
          ) : (
            <Skeleton />
          )}
        </Grid>
      )}
    </Grid>
  );
}
